export const container = ({ width }) => ({
    width,
    position: 'relative',
});

export const extendContainer = {
    container: () => ({
        paddingTop: 0,
        maxWidth: '80vw',

        paddingLeft: 0,
        paddingRight: 0,

        tabletLarge: {
            maxHeight: 'unset',
            paddingTop: 0,
        },
    }),
};

export const link = () => ({
    display: 'flex',
    textDecoration: 'none',
    cursor: 'none',

    flexDirection: 'column',

    tablet: {
        flexDirection: 'row',
        alignItems: 'flex-end',
    },
});

export const text = ({ theme: { colors } }) => ({
    color: colors.blue,
    fontSize: '2rem',
    fontWeight: 'bold',
    marginBottom: '0.625rem',

    tablet: {
        marginRight: '1.25rem',
    },
});

export const image = () => ({
    maxWidth: '80%',

    tablet: {
        maxWidth: 'unset',
    },
});
